

























import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({})
export default class IconCard extends Vue {
  @Prop()
  to: object

  @Prop()
  title: string

  @Prop()
  text: string

  @Prop()
  icon: string

  @Prop({
    default: false
  })
  disabled: boolean

  @Prop()
  disabledText: string

  @Prop({
    default: false
  })
  loading: boolean

  @Prop({
    default: 'auto'
  })
  maxWidth: string

  @Prop({
    default: 'cil'
  })
  iconPack: string

  @Prop()
  betaText: string

  @Prop({
    default: 'BETA'
  })
  betaTag: string

  @Prop({
    default: null
  })
  grow: any

  @Prop({
    default: null
  })
  mini: any

  @Prop()
  onClickHandler: Function
}
